if ((role.developer || role.tester) && web.browser != "IE") {
  var xlog = console.log;
  var log = xlog;

  $(document).on("click", "[data-viewport]", function(e) {
    e.stopPropagation();
    window.open($(this).data("path"), "_self");
  });

  $(document).on("keydown", function(e) {
    if (e.which === 115) {
      if (Object.keys(web.get).length === 0) {
        window.open(web.lineage_current + "?viewport=1", "_self");
        return;
      }

      var get = Object.keys(web.get)
        .map(function(key) {
          if (key === "viewport" && web.get.viewport) {
            return "";
          }
          return key + "=" + web.get[key];
        })
        .join("&");

      if (get.length > 1) {
        if (web.get.viewport) {
          window.open(web.lineage_current + "?" + get.slice(0, -1), "_self");
          return;
        } else {
          window.open(web.lineage_current + "?" + get + "&viewport=1", "_self");
          return;
        }
      } else {
        window.open(web.lineage_current, "_self");
        return;
      }
    }
  });
} else {
  var xlog = function() {};
  var log = xlog;
}

/* if (role.developer || role.tester) {
  window.onerror = function(message, source, lineno, colno, error) {
    alert(
      "Message:" +
        message +
        "\nSource:" +
        source +
        "\nLine:" +
        lineno +
        "\nCol:" +
        colno +
        "\n" +
        error
    );
  };
} else {
  window.onerror = function(message, source, lineno, colno, error) {};
} */

function xlogc(text, obj, size, type) {
	if (!role.developer && !role.tester){
		return;
	}
	
	switch (size) {
		case 0:
			size = "font-size: 12px;";
			break;
		case 1:
			size = "font-size: 20px;";
			break;
		case 2:
			size = "font-size: 30px;";
			break;
		default:
			size = "font-size: 12px;";
			break;
	}

	switch (type) {
		case "success":
			icon = "✔️";
			type = "color: #38BB38;";
			break;
		case "error":
			icon = "❌";
			type = "color: Red;";
			break;
		case "info":
			icon = "ℹ️";
			type = "color: #28C8F0;";
			break;
		case "warning":
			icon = "⚠️";
			type = "color: #FFD337;";
			break;
		default:
			icon='';
			type = "color: #FFD337;";
			break;
	}
	
	console.log("%c" + icon + " " + text, type + size);
	console.log(obj);
}

var js = {};
js.open = function(type){
    path = 'localexplorer:\\\\192.168.2.18\\www-data\\dev\\dev.lexitacrm.lt\\static\\js\\plugins\\'+ type +'.js';
    window.open(path);
}